import React from 'react';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';

function StagesMobile() {
    return (
        <div className="stages-mobile">
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                <CommonSmallTitle className="stages__small-title">
                    Анализ и стратегия
                </CommonSmallTitle>
                <CommonSmallText className="stages__text">
                    На старте провели анализ показателей по прошлым рекламным кампаниям в разрезе
                    количества и стоимости качественных лидов. Изучили текущие показатели по
                    запросам в поисковых системах, определили приоритетные целевые аудитории для тех
                    видов техники, которые были заявлены заказчиком для продвижения: цистерны,
                    агротехника и шторные полуприцепы.
                </CommonSmallText>
                <CommonSmallText className="stages__text">
                    Из-за сложности ниши мы постоянно генерировали новые гипотезы и тестировали их.
                    За весь период рекламной кампании наша команда протестировала 426 гипотез, на
                    проработку которых ушло более 500 часов.
                </CommonSmallText>
                <CommonSmallText className="stages__text">
                    В данном кейсе мы использовали связку таргетированной и контекстной рекламы. За
                    год мы сделали 226 рекламных запусков в Яндекс.Директ, Google Ads,
                    таргетированной рекламе в Facebook*, &laquo;ВКонтакте&raquo;. Тестировали каждую
                    гипотезу и и креатив, чтобы найти целевую аудиторию для техники BONUM, расширяли
                    семантику.
                </CommonSmallText>
            </ScrollAnimation>
            <ScrollAnimation animateIn="zoomIn" offset={0} animateOnce={true} duration={1.2}>
                <img
                    className="stages__starts"
                    src="/images/svg/bonum/starts.svg"
                    alt="arrow"
                    loading="lazy"
                />
            </ScrollAnimation>
            <div>
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <CommonSmallTitle className="stages__small-title">
                        Рекламные запуски
                    </CommonSmallTitle>
                </ScrollAnimation>

                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <CommonSmallText className="stages__text">
                        <span className="stages__text--bold">Для продвижения цистерн</span>{' '}
                        изначально использовали поисковые РК по прямым, брендовым и конкурентным
                        ключам в Яндексе. Результат получили сразу. За первые три месяца 2021 года
                        количество верифицированных лидов увеличилось в 1,5 раза по сравнению с 4
                        кварталом 2020 г. и резко (на 40%) снизилась цена верифицированного лида.
                        Тестировали и другие гипотезы, каналы, но первоначальная стратегия оказалась
                        самой лучшей, ее и продолжили использовать.
                    </CommonSmallText>

                    <CommonSmallText className="stages__text">
                        К концу года нам удалось увеличить количество верифицированных лидов на 21%
                        и снизить их стоимость привлечения на 17,5%. ROI этой рекламной кампании
                        превысил 6500%. Крайне неудачно сработала реклама во
                        &laquo;ВКонтакте&raquo;: цена лида со всех гипотез выходила в 2-3 раза выше,
                        чем из других источников.
                    </CommonSmallText>

                    <CommonSmallText className="stages__text">
                        <span className="stages__text--bold">Запуск по агротехнике</span> стартовал
                        с Яндекс.Директ по прямым, брендовым, околосемантическим ключам. Уже за
                        первые три месяца работы количество верифицированных лидов увеличилось на
                        40% по сравнению с 4 кварталом 2020 г., также выросла доля качественных
                        лидов на 3% (до 12%) и начала снижаться цена верифицированных лидов (-3%).
                        Далее подключили ретаргет в соцсетях в рамках тестирования новых гипотез.
                        Неудачным каналом для продвижения это вида техники стал Google Ads где
                        ценовое значение лида со всех гипотез повышалось в 1,5-2 раза.
                    </CommonSmallText>

                    <CommonSmallText className="stages__text">
                        За 2021 год количество верифицированных лидов увеличилось на 130%, доля
                        качественных лидов выросла до 18%. ROI по этой рекламной кампании превысил
                        4500%.
                    </CommonSmallText>

                    <CommonSmallText className="stages__text">
                        <span className="stages__text--bold">Рекламу по шторным полуприцепам</span>{' '}
                        запускали тестово на полтора месяца, так как это новый вид техники от завода
                        BONUM. В этой кампании также неудачно сработал канал Google Ads, а
                        Яндекс.Директ принес максимальный результат. В этом рекламном запуске
                        получили самые недорогие качественные лиды: в 2,5 раза дешевле, чем в
                        продвижении агротехники и цистерн. При этом каждый 5-й лид прошел
                        верификацию у клиента.
                    </CommonSmallText>
                </ScrollAnimation>
                <ScrollAnimation
                    className="stages-mobile__truck"
                    animateIn="zoomIn"
                    offset={0}
                    animateOnce={true}
                    duration={1.2}
                >
                    <img src="/images/pic/bonum/stages.png" alt="stages" loading="lazy" />
                </ScrollAnimation>
                <ScrollAnimation animateIn="zoomIn" offset={0} animateOnce={true} duration={1.2}>
                    <img
                        className="stages__monitoring stages__monitoring--mobile"
                        src="/images/svg/bonum/monitoring.svg"
                        alt="arrow"
                        loading="lazy"
                    />
                </ScrollAnimation>
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <CommonSmallTitle className="stages__small-title">Мониторинг</CommonSmallTitle>
                    <CommonSmallText className="stages__text">
                        Процесс мониторинга, корректировки гипотез и результатов проводился
                        ежедневно для поддержания оптимальной цены лида по всем направлениям.
                        Успешность гипотезы/инструмента оценивали по качеству трафика, показателю
                        отказов, глубине просмотра, микроконверсиям и стоимости качественного лида,
                        который прошел верификацию в кол-центре клиента. Целевыми считались только
                        те, лиды у которых есть интерес к приобретению техники.
                    </CommonSmallText>
                </ScrollAnimation>
            </div>
        </div>
    );
}

export default StagesMobile;
